<script setup lang="ts">
import { RouterView } from 'vue-router'
import { Toaster } from 'vue-sonner'
import dayjs from 'dayjs'
import 'dayjs/locale/zh-cn'
import 'vue-sonner/style.css'

dayjs.locale('zh-cn')
</script>

<template>
  <RouterView />
  <Toaster position="top-right" :gap="10" :toast-options="{ unstyled: false, style: { maxWidth: '420px' } }" rich-colors />
</template>

<style>
#app {
  height: 100vh;
  min-width: 1280px;
}

#app:has(> .incident-h5-page) {
  min-width: 0;
}
</style>
